import { useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import axios from "../../../../services/department-viags/config.service";
import { BaseResponse } from "../../../chats/types";

interface DeleteFolderSchema {
  key: string;
}

const BASE_PATH = "/edoc";

const folderApi = {
  delete: async (body: DeleteFolderSchema, config?: AxiosRequestConfig) => {
    await axios.post<BaseResponse<unknown>>(`${BASE_PATH}/delete-folder`, body, config);
  },
};

const useDeleteFolder = () => {
  return useMutation({
    mutationFn: (body: DeleteFolderSchema) => folderApi.delete(body),
  });
};

export default useDeleteFolder;
